<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Set Backlight" icon="☀" color="#d97706">
        <label>State</label>
        <select :value="props.data.state !== false ? '1' : '0'" @change="update('state', $event.target.value === '1')">
            <option value="1">On</option>
            <option value="0">Off</option>
        </select>

        <label>Brightness (1–255)</label>
        <div class="flex items-center gap-2">
            <input type="range" min="1" max="255"
                :value="props.data.brightness ?? 128"
                @input="update('brightness', parseInt($event.target.value))"
                class="flex-1 h-1 accent-yellow-400" style="width:100%;background:transparent;border:none;padding:0" />
            <span class="text-gray-300 w-8 text-right">{{ props.data.brightness ?? 128 }}</span>
        </div>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });
</script>
